import { Component } from "@angular/core";
import { DeckCard } from "@apiserver-rest/ponder-data-client-base";
import { NgClass } from "@angular/common";
import { DeckGroupComponent } from "@ponder-features/user/decks/deck/group/deck-group.component";
import { MagicDeckMultiRowComponent } from "./magic-deck-multi-row.component";

@Component({
    selector: "magic-deck-group",
    imports: [MagicDeckMultiRowComponent, NgClass],
    templateUrl: "./magic-deck-group.component.html"
})
export class MagicDeckGroupComponent extends DeckGroupComponent {

    public constructor() {
        super();
    }

    public onCardHover(deckCard: DeckCard): void {
        this.deckComponent.onCardHover(deckCard);
    }

    public override addCard(deckCard: DeckCard): void {
        super.addCard(deckCard);
    }

    public override removeCard(deckCard: DeckCard): void {
        super.removeCard(deckCard);
    }
}